module.exports = __webpack_public_path__ + "static/media/gambling.0589d6f4.svg";